import { useEffect, useState } from "react";

const useGetProducts = () => {
  const [productsArr, setProductsArr] = useState([]);
  const [categoriesArr, setCategoriesArr] = useState([]);

  useEffect(() => {
    // ?skip=0&limit=100
    fetch("https://dummyjson.com/products/?skip=0&limit=100")
      .then((res) => res.json())
      .then((data) => setProductsArr(data));
  }, []);
  useEffect(() => {
    fetch("https://dummyjson.com/products/categories")
      .then((res) => res.json())
      .then((data) => setCategoriesArr(data));
  }, []);

  return { productsArr, categoriesArr };
};

export default useGetProducts;
